import React, { useState } from 'react';
import './Schedule.css';

const scheduleData = {
  Yesterday: [
    { time: '09:00 AM - 10:00 AM', patient: 'Alex Green', purpose: 'General Checkup' },
    { time: '11:00 AM- 12:30 PM', patient: 'Nina Park', purpose: 'X-ray Review' },
  ],
  Today: [
    { time: '10:00 AM - 11:30 AM', patient: 'John Doe', purpose: 'Follow-up' },
    { time: '11:30 AM - 12.00 PM', patient: 'Jane Smith', purpose: 'Consultation' },
    { time: '01:00 PM - 02:00 PM', patient: 'Sam Wilson', purpose: 'Therapy Session' },
  ],
  Tomorrow: [
    { time: '09:30 AM - 10:00 AM', patient: 'Linda Johnson', purpose: 'Dental Check' },
    { time: '02:00 PM - 03:00 PM', patient: 'Robert Brown', purpose: 'Eye Test' },
  ],
};

const upcomingEvents = [
  { title: 'Staff Meeting', date: '2025-06-20', time: '04:00 PM' },
  { title: 'Health Camp', date: '2025-06-22', time: '09:00 AM' },
  { title: 'Medical Conference', date: '2025-06-25', time: '10:00 AM' },
];

const candidateMeetings = [
  { name: 'Dr. Ayesha Khan', role: 'Pediatrician', time: '3:00 PM', status: 'Scheduled' },
  { name: 'Dr. Mark Lee', role: 'Orthopedic Surgeon', time: '3:30 PM', status: 'Pending' },
];

const personalReminders = [
  { task: 'Pick up kids from school', time: '05:00 PM' },
  { task: 'Buy groceries (milk, eggs, bread)', time: 'After work' },
  { task: 'Call plumber to fix sink', time: 'Evening' },
];

const Schedule = () => {
  const [activeDay, setActiveDay] = useState('Today');

  return (
    <div className="schedule-container">
      {/* Day Tabs */}
      <div className="day-tabs">
        {['Yesterday', 'Today', 'Tomorrow'].map((day) => (
          <button
            key={day}
            className={`day-tab ${activeDay === day ? 'active' : ''}`}
            onClick={() => setActiveDay(day)}
          >
            {day}
          </button>
        ))}
      </div>

      {/* Schedule Table */}
      <table className="data-table">
        <thead>
          <tr>
            <th>Time</th>
            <th>Patient</th>
            <th>Purpose</th>
          </tr>
        </thead>
        <tbody>
          {scheduleData[activeDay]?.map((item, index) => (
            <tr key={index}>
              <td>{item.time}</td>
              <td>{item.patient}</td>
              <td>{item.purpose}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Upcoming Events */}
      <div className="upcoming-events">
        <h3>Upcoming Events</h3>
        <div className="event-grid">
          {upcomingEvents.map((event, index) => (
            <div key={index} className="event-card">
              <div className="event-title">{event.title}</div>
              <div className="event-date">{event.date}</div>
              <div className="event-time">{event.time}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Candidate Meetings */}
      <div className="candidate-meetings">
        <h3>Meetings with Candidates</h3>
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Role</th>
              <th>Time</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {candidateMeetings.map((candidate, index) => (
              <tr key={index}>
                <td>{candidate.name}</td>
                <td>{candidate.role}</td>
                <td>{candidate.time}</td>
                <td>{candidate.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Personal Reminders */}
      <div className="personal-reminders">
        <h3>Personal Reminders</h3>
        <ul>
          {personalReminders.map((reminder, index) => (
            <li key={index}>
              <strong>{reminder.task}</strong> <span style={{ color: '#777' }}>({reminder.time})</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Schedule;
